export enum AIAvatarGender {
    MALE = "MALE",
    FEMALE = "FEMALE",
    NEUTRAL = "NEUTRAL",
    UNKNOWN = "UNKNOWN"
}
